import $ from 'jquery';

const prom = $.Deferred();
prom.resolve();

function resolvePromise() {
    return prom;
}

export default resolvePromise;
